import { render, staticRenderFns } from "./model-r1-recipient-inference.vue?vue&type=template&id=5aff2ace&scoped=true&"
import script from "./model-r1-recipient-inference.vue?vue&type=script&lang=js&"
export * from "./model-r1-recipient-inference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aff2ace",
  null
  
)

export default component.exports